import { get } from 'svelte/store';

import { userID, isLogin, omegaParams } from '../store/index';

import { isMsiPage, resolveDefaultUiType, resolvePubPage } from './pageType';
import {
    resolveTrackPageId,
    resolveTrackPageVersion
} from './trackPageId';

import {
    buildCreditCardCommonParams,
    getAdvParameters
} from '@/utils/creditCardTrackParams';
import { getParamsUI, GROUP_TYPE_PARAM, UI_TYPES } from '@/utils/group';
import { trackEvent as trackEventFn } from '@/utils/omega';
import { TECH_PAGE_MODULE_SW } from '@/utils/techTrack';
import url from '@/utils/url';

type TrackAttrs = {
    [key: string]:
        | string
        | boolean
        | number
        | object
        | []
        | undefined
        | null;
};

const getIsLoginParam = () => (get(isLogin) ? 1 : 0);

const buildCardMsiIdentityParams = () => ({
    group_type: url.get('group_type') || 'group_a',
    from_traffic_cnn: url.get('from_traffic_cnn') || '',
    pub_from_quickbolt: url.get('pub_from_quickbolt') || '',
    relation_id: url.get('relation_id') || '',
    is_sign: getIsLoginParam(),
    is_login: getIsLoginParam()
});

const buildPublicTrackParams = (pubPage: string, ext?: Record<string, unknown>) => {
    const commonParams = buildCreditCardCommonParams({
        pubPage,
        uid: get(userID),
        pub_uid: get(userID),
        ext: {
            ...getAdvParameters(),
            ui_type:
                (ext?.ui_type as string) ||
                getParamsUI(
                    GROUP_TYPE_PARAM,
                    UI_TYPES,
                    resolveDefaultUiType()
                ),
            page_source: 'creditcard',
            ...ext
        }
    });

    const identityParams = buildCardMsiIdentityParams();

    if (!isMsiPage()) {
        return {
            ...commonParams,
            ...identityParams
        };
    }

    const resolvedPageId = resolveTrackPageId();

    return {
        ...commonParams,
        page_id: resolvedPageId,
        page_version: resolveTrackPageVersion(),
        page_name: resolvedPageId,
        ...identityParams
    };
};

export const refreshOmegaParams = (ext?: Record<string, unknown>) => {
    try {
        const pubPage = (ext?.pub_page as string) || resolvePubPage();
        const commonParams = buildPublicTrackParams(pubPage, ext);

        omegaParams.set(commonParams);

        return commonParams;
    } catch (error) {
        console.error(error);
    }
};

export const prepareOmegaParams = () => refreshOmegaParams();

export const trackEvent = (eventId: string, attrs?: TrackAttrs) => {
    try {
        const pubPage = resolvePubPage();
        const publicParams = {
            ...buildPublicTrackParams(pubPage),
            ...attrs
        };

        omegaParams.set(publicParams);

        return trackEventFn(eventId, publicParams);
    } catch (error) {
        console.error(error);
    }
};

export const trackEventModuleSw = (module: string) => {
    return trackEvent(TECH_PAGE_MODULE_SW, { module });
};

export const callErrorTrack = (type: string, errmsg?: string) => {
    try {
        trackEventFn('pub_marketing_call_error_bt', {
            ...buildPublicTrackParams(resolvePubPage()),
            type,
            errmsg,
            ext: {
                ...url.parseQuery()
            }
        });
    } catch (error) {
        console.error(error);
    }
};
